<div class="main">
  <div class="list-button-container">
    <div class="buttonContainer">
      <button
        mat-flat-button
        color="accent"
        class="createNewCourseCategoryBtn"
        (click)="createNewCourseCategory()"
        >
        Ny Kategori
      </button>
    </div>
    @if (!isHistory) {
      <div class="list-container">
        <lib-list-view
          #listView
          [headerList]="headerList"
          (rowClick)="openCourseCategoryDialog($event)"
          [extraBurgerMenuOptions]="extraBurgerMenuOptions"
          >
        </lib-list-view>
      </div>
    }
    @if (isHistory) {
      <div class="list-container">
        <lib-list-view
          #logListView
          [headerList]="logHeaderList"
          [extraBurgerMenuOptions]="extraBurgerMenuOptions"
          >
        </lib-list-view>
      </div>
    }
  </div>
</div>
